import { useListboxContext as useListboxContext$1 } from '@reach/listbox';
import { LegacyBasicListbox as LegacyBasicListbox$1 } from './legacy.basic-listbox.component.js';
import { LegacyListbox as LegacyListbox$1 } from './legacy.listbox.component.js';
import { deprecatedComponent } from '../../../react/components/core/deprecated-component.js';
/**
 * @deprecated
 */

var useListboxContext = useListboxContext$1;
/**
 * @deprecated Use new Listbox and its sub-components instead
 */

var LegacyBasicListbox = deprecatedComponent({
  displayName: 'LegacyBasicListbox',
  root: LegacyBasicListbox$1,
  description: 'Legacy Basic Listbox is Deprecated. Migrate to new Listbox'
});
/**
 * @deprecated Use new Listbox and its sub-components instead
 */

var LegacyListbox = deprecatedComponent({
  displayName: 'LegacyListbox',
  root: LegacyListbox$1,
  description: 'Legacy ReachUI Listbox is Deprecated. Migrate to new Listbox'
})
/* PLOP_COMPONENT_EXPORT_IN_INDEX */
;
export { LegacyBasicListbox, LegacyListbox, useListboxContext };